module.exports = __webpack_public_path__ + "static/media/Banner(SignUpGIC).daff1432.jpg";